
const ReportsTranslation = {
    
    // Report preview
    _reportPreviewFooterDetails: {
        pt_br: 'Gerado em {date} às {hour} pelo usuário {user}',
        en_us: 'Generated on {date} at {hour} by user {user}',
        es_es: 'Generado el {date} a las {hour} por el usuario {user}'
    },
    
    
    // Reports
    // Governance
    // Room Overview
    _roomOverviewDescription: {
        pt_br: 'Listagem com a situação atual das UHs',
        en_us: 'List with current room situation',
        es_es: 'Listado con la situación actual de las habitaciones'
    },

    _roomOverviewEmptyRoomList: {
        pt_br: 'Nenhuma UH encontrada com os filtros selecionados',
        en_us: 'No rooms found with the selected filters',
        es_es: 'No se encontraron habitaciones con los filtros seleccionados'
    },


    // Room Log
    _roomLogDescription: {
        pt_br: 'Log de alterações realizadas por UH',
        en_us: 'Log of changes made by room',
        es_es: 'Registro de cambios realizados por habitación'
    },

    _roomLogEmptyRoomList: {
        pt_br: 'Nenhum registro de log encontrado com os filtros selecionados',
        en_us: 'No log records found with selected filters',
        es_es: 'No se encontraron registros con los filtros seleccionados'
    },

    _roomLogChangeGovernanceStatusAction: {
        pt_br: 'Alteração do status de governança',
        en_us: 'Changing governance status',
        es_es: 'Cambiar el estado de gobernanza'
    },

    _roomLogChangeDoNotDisturbStatusAction: {
        pt_br: 'Alteração do status de "não perturbe"',
        en_us: 'Changing "do not disturb" status',
        es_es: 'Cambiar el estado de "no molestar"'
    },

    _roomLogChangeExecutionPriorityAction: {
        pt_br: 'Alteração da prioridade de execução',
        en_us: 'Changing execution priority',
        es_es: 'Cambiar la prioridad de ejecución'
    },


    // Service
    // Service Orders
    _serviceOrdersDescription: {
        pt_br: 'Listagem com a situação atual das ordens de serviço',
        en_us: 'List with current service orders situation',
        es_es: 'Listado con la situación actual de las ordens de servicio'
    },

    _serviceOrdersEmptyList: {
        pt_br: 'Nenhuma ordem de serviço encontrada com os filtros selecionados',
        en_us: 'No service order found with the selected filters',
        es_es: 'No se encontraron orden de servicio con los filtros seleccionados'
    },


    // Service Order Log
    _serviceOrderLogDescription: {
        pt_br: 'Log de alterações realizadas por ordem de serviço',
        en_us: 'Log of changes made by service order',
        es_es: 'Registro de cambios realizados por orden de servicio'
    },

    _serviceOrderLogEmptyRoomList: {
        pt_br: 'Nenhum registro de log encontrado com os filtros selecionados',
        en_us: 'No log records found with selected filters',
        es_es: 'No se encontraron registros con los filtros seleccionados'
    },

    _serviceOrderLogChangeStatusAction: {
        pt_br: 'Alteração do status',
        en_us: 'Changing status',
        es_es: 'Cambiar el estado'
    },

    _serviceOrderLogChangePriorityAction: {
        pt_br: 'Alteração da prioridade',
        en_us: 'Changing priority',
        es_es: 'Cambiar la prioridad'
    },

    _serviceOrderLogChangeDepartmentAction: {
        pt_br: 'Alteração do departamento',
        en_us: 'Changing department',
        es_es: 'Cambiar el departamento'
    },

    _serviceOrderLogChangeResponsibleAction: {
        pt_br: 'Alteração do responsável',
        en_us: 'Changing responsible',
        es_es: 'Cambiar el responsable'
    },

    _serviceOrderLogChangeStartDateAction: {
        pt_br: 'Alteração da data de início',
        en_us: 'Changing start date',
        es_es: 'Cambiar el fecha de inicio'
    },

    _serviceOrderLogChangeEstimatedCompletionDateAction: {
        pt_br: 'Alteração da data de conclusão estimada',
        en_us: 'Changing estimated completion date',
        es_es: 'Cambiar el fecha estimada de finalización'
    },


    // Service Orders by Tag
    _serviceOrdersByTagDescription: {
        pt_br: 'Totalizadores de ordens de serviços por tag',
        en_us: 'Service order totalizers by tag',
        es_es: 'Totalización de órdenes de trabajo por tag'
    },

    _serviceOrdersByTagEmptyList: {
        pt_br: 'Nenhuma tag encontrada com os filtros selecionados',
        en_us: 'No tag found with the selected filters',
        es_es: 'No se encontraron tag con los filtros seleccionados'
    },


    // Defaults
    // Statistical Log
    _statisticalLogDescription: {
        pt_br: 'Estatísticas operacionais por usuário',
        en_us: 'Operational statistics by user',
        es_es: 'Estadísticas operativas por usuario'
    },

    _statisticalLogEmptyUserList: {
        pt_br: 'Nenhum usuário encontrado com os filtros selecionados',
        en_us: 'No users found with the selected filters',
        es_es: 'No se han encontrado usuarios con los filtros seleccionados'
    },

    _statisticalLogAverageOfPerRequest: {
        pt_br: 'Média de {value} por solicitação',
        en_us: 'Average of {value} per request',
        es_es: 'Promedio de {value} por solicitudes'
    },

    _statisticalLogAverageOfPerRoom: {
        pt_br: 'Média de {value} por UH',
        en_us: 'Average of {value} per room',
        es_es: 'Promedio de {value} por habitación'
    }
}

export default ReportsTranslation;